import { PageLayout } from '@kcftech/design-system';
import { DropdownTriggerOptions } from 'components/dropdown/Dropdown';
import { dropdownTriggerStyles } from 'pages/Desk/issues/issue_modals/shared';
import { CSSProperties } from 'react';
import styled from 'styled-components';

export const IssuesPageLayout = styled(PageLayout.Primary)`
    display: flex;
    flex-direction: column;
    height: auto !important;
    overflow-y: hidden !important;
    padding-bottom: 2rem;
    gap: 1.5rem;
`;

export const FilterAndSearchContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const UpdateAndSearchContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

export const IssuesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`;

export const IconWrapper = styled.div<{ $backgroundColor: string; $padding?: string }>`
    width: 2rem;
    height: 2rem;
    padding: ${({ $padding }) => $padding ?? '1rem'};
    line-height: 2rem;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

export const Text = styled.div`
    font-size: 1.4rem;
`;

export const BoldText = styled(Text)`
    font-weight: 500;
`;

export const Separator = styled.div`
    border-right: 1px solid var(--input-border);
`;

export function useIssueSidebarDropdownTriggerOptions(
    style?: CSSProperties
): DropdownTriggerOptions {
    return {
        paddingOverride: '1.5y',
        style: { ...dropdownTriggerStyles, ...style },
    };
}
